import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { IntegrationsProvider } from './context/IntegrationsContext';
import { GLOBAL_STYLES } from './components/ui';

/**
 * Scoped shell for integration module routes: context + design tokens CSS.
 * Renders inside DashboardRoot (no duplicate sidebar).
 */
export function IntegrationsShell() {
  useEffect(() => {
    const id = 'cm-integrations-module-styles';
    if (document.getElementById(id)) return;
    const el = document.createElement('style');
    el.id = id;
    el.textContent = GLOBAL_STYLES;
    document.head.appendChild(el);
  }, []);

  return (
    <IntegrationsProvider>
      <div className="integrations-module h-full min-h-0 overflow-auto">
        <Outlet />
      </div>
    </IntegrationsProvider>
  );
}
